export default __webpack_public_path__ + "static/social-default-image-00131e13c06622c27e1b3200f900b25a.png";